import React from 'react';
import classnames from 'classnames'
import Presenter from '../../../presenter.js';
import Request from '../../request.props.js';

import MaintenanceRequestRow from './MaintenanceRequestRow.js';
import Pagination from '../../../../component/Pagination.js';
import {HandlingSometingWentWrong} from '../../../../utils/HandlingMessage.js';
import windowStop from '../../../../utils/windowStop.js';

export default class MaintenanceRequestList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading       : true,
      loadingLoadMore : true,
      isSometingWrong : false,
      rawData         : [],
      NextPage        : null,
      // ***Pagination
      table_loading : false,
      current       : 0,
      limit         : 0,
      count         : 0,
    }
    this.tmpAlias   = null;
    this.paramsPage = 1;
    this.onRead        = this.onRead.bind(this)
    this.onReadSuccess = this.onReadSuccess.bind(this)
    this.onReadFailed  = this.onReadFailed.bind(this)
    this._mounted      = false;
  }

  generateRow(row) {
    var element = row.map((val, index) => {
      return (<MaintenanceRequestRow RowData={val} key={val.Alias} />)
    })
    return element;
  }

  onRead(action) {
    if (this._mounted){
      Presenter.ReadByAsset(
        Request.ReadByAsset(action, this, this.onReadSuccess, this.onReadFailed, this.paramsPage)
      )
    }
  }

  onReadSuccess(params, response) {
    if(params.action === 'Request') {
      this.setState({
        isLoading       : false,
        loadingLoadMore : false,
        isSometingWrong : false,
        table_loading   : false,
        rawData         : response.data.results,
        NextPage        : response.data.next,
        current         : response.data.current,
        limit           : response.data.limit,
        count           : response.data.count,
      })
    }
  }

  onReadFailed(response) {  
    this.setState({
      isLoading: false,
      table_loading: false
    })
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.hardReload) {
      this.onRead('Request')
      this.props.stopHardReload()
    }
  }

  componentWillUnmount() {
    this._mounted = false;
    windowStop()
  }

  componentDidMount() {
    this._mounted = true;
    this.onRead('Request'); 
  }

  LoadMore() {        
    this.setState({loadingLoadMore: true,})
    this.onRead('Next')
  }

  handlePageClick = (data) => {
    windowStop()
    let selected = data.selected + 1;
    this.paramsPage = selected
    
    this.setState({ table_loading: true})

    this.onRead('Request');
  };

  RenderLoadMoreButton() {
    if(this.state.loadingLoadMore) {
      return(
        <div>
          <button className="btn btn-default" disabled><i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Loading</button>
        </div>
      )
    } else {
      if(this.state.NextPage != null) {
        return (
          <div>
            <button className="btn btn-primary" onClick={()=> {this.LoadMore()}}>Load More</button>
          </div>
        )
      }
    }
  }

  renderRowElement() {
    if ( this.state.isLoading ) {
      return (<tr><td className="table-loading-inside" colSpan="100%">Loading data . . .</td></tr>)
    } 
    else if(this.state.isLoading === false && this.state.isSometingWrong === true){
      return(HandlingSometingWentWrong('table'))
    }
    else if (this.state.rawData.length === 0) {
      return (<tr><td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;data empty</td></tr>)
    } 
    else if (this.state.rawData.length > 0) {
      return (this.generateRow(this.state.rawData))
    } 
    else {
      return(HandlingSometingWentWrong('table'))
    }
  }

  render() {
    // let {rawData, isLoading} = this.state 
    // let dataRow= null;

    // if(isLoading === 'loading') {
    //   dataRow = <tr><td className="table-loading-inside" colSpan="100%">Loading data . . .</td></tr>;

    // } else if(isLoading === 'success' && rawData.length === 0) {
    //   dataRow = <tr><td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;data empty</td></tr>;

    // } else if (isLoading === 'success' && rawData.length >= 0) {
    //   dataRow = this.generateRow(rawData)

    // } else if(isLoading === 'failed') {
    //   dataRow = <tr><td className="table-loading-inside" colSpan="100%">Failed load data, Please Refresh this page</td></tr>;

    // } else {
    //   dataRow = <tr><td className="table-loading-inside" colSpan="100%">Something went wrong</td></tr>;
    // }

    return (
      <div>
        <table className={classnames("table table-hover table-outline mb-0 m-top-15", {"loading" : this.state.table_loading})}>
          <thead className="thead-default">
            <tr>
              <th>Maintenance Type</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowElement()}
          </tbody>
        </table>
        <div className="row m-top-15">
          <div className="col-md-12 text-center">
            <Pagination
              current  = {this.state.current}
              count    = {this.state.count}
              limit    = {this.state.limit}
              handle   = {this.handlePageClick}
              isLoading= {this.state.table_loading}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/maintenance/helper/component/MaintenanceRequestList/MaintenanceRequestList.js